// hooks/useValidator.js
import { useState } from 'react';

export const useValidator = () => {
  const [errors, setErrors] = useState({});

  const validateField = (value, rules) => {
    if (rules.required && !value) {
      return rules.required;
    }
    if (rules.type && rules.type.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return rules.type.email;
      }
    }
    return null;
  };

  const getErrors = (data, validationRules) => {
    const newErrors = {};

    Object.keys(validationRules).forEach(field => {
      const value = data[field];
      const rules = validationRules[field];

      if (typeof rules === 'string') {
        const error = validateField(value, { required: rules });
        if (error) newErrors[field] = error;
      } else if (typeof rules === 'object') {
        if (rules.condition && !data[field]) {
          return; // Skip validation if condition is not met
        }
        if (rules.children) {
          Object.keys(rules.children).forEach(childField => {
            const childValue = data[childField];
            const childRules = rules.children[childField];
            const error = validateField(childValue, childRules);
            if (error) newErrors[childField] = error;
          });
        } else {
          const error = validateField(value, rules);
          if (error) newErrors[field] = error;
        }
      }
    });

    setErrors(newErrors);
    return newErrors;
  };

  return { getErrors, errors };
};